/*
 * function created to format date
 */
export default function formatDate(dateValue){
    let date = new Date(dateValue);
    const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' };
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
}